var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGoogle({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "128px",
    height: "120px",
    viewBox: "0 0 128 120",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 6") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-6"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-9",
    stroke: "#E7EEF1",
    fill: "#F4F7FC",
    x: 0.5,
    y: 0.5,
    width: 127,
    height: 119,
    rx: 8
  }), /*#__PURE__*/React.createElement("g", {
    id: "google-ads",
    transform: "translate(39, 37)",
    fill: "#37474F",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(0.9304, 10.7582)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.820678957,24.2572278 C0.685979104,24.2572278 0.547993888,24.2227315 0.423150121,24.1537389 C0.0256212849,23.9319769 -0.117291974,23.4342446 0.10446998,23.035073 L12.6676953,0.420281772 C12.8878146,0.0260382986 13.3888324,-0.11523228 13.7847185,0.101601631 C14.1822474,0.323363585 14.3251606,0.821095971 14.1033987,1.22026749 L1.53853062,23.8367014 C1.38904663,24.1061011 1.10979084,24.2572278 0.820678957,24.2572278 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.7436515,31.4390298 C13.6089516,31.4390298 13.4709664,31.4045335 13.3461227,31.3355409 C12.9485938,31.1137789 12.8056806,30.6160465 13.0274425,30.216875 L20.9057413,16.033966 C21.1242179,15.6397225 21.6252356,15.498452 22.0227644,15.7152859 C22.4202933,15.9370478 22.5632065,16.4347802 22.3414446,16.8339517 L14.4631458,31.0168607 C14.3120192,31.2862604 14.0327634,31.4390298 13.7436515,31.4390298 L13.7436515,31.4390298 Z",
    id: "Path"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.1621969,22.6082205 L13.9578617,40.9750384 C12.7997715,43.0612434 10.596936,44.3573189 8.20847766,44.3573189 C7.10131057,44.3573189 5.99907153,44.0698497 5.02331893,43.5277649 C1.85622969,41.7700961 0.711280934,37.7603114 2.47059244,34.5948648 L14.9188301,12.1903367 C15.1389494,11.7944506 14.9960361,11.2934328 14.60015,11.0716709 C14.2059065,10.8531943 13.7048888,10.9961076 13.4831268,11.390351 L1.03324644,33.7948791 C-1.16630361,37.7537407 0.264471664,42.7639182 4.22333321,44.9651109 C5.44220262,45.6418955 6.81876942,46 8.2051923,46 C11.1899439,46 13.9430775,44.3819591 15.3919223,41.7750241 L25.1182373,24.2673285 L24.1621969,22.6082205 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.21340571,45.9983573 C3.6845338,45.9983573 0,42.3138235 0,37.7849516 C0,33.2560797 3.6845338,29.5715459 8.21340571,29.5715459 C12.7422776,29.5715459 16.4268114,33.2560797 16.4268114,37.7849516 C16.4268114,42.3138235 12.7422776,45.9983573 8.21340571,45.9983573 Z M8.21340571,31.214227 C4.58965111,31.214227 1.64268114,34.161197 1.64268114,37.7849516 C1.64268114,41.4087062 4.58965111,44.3556762 8.21340571,44.3556762 C11.8371603,44.3556762 14.7841303,41.4087062 14.7841303,37.7849516 C14.7841303,34.161197 11.8371603,31.214227 8.21340571,31.214227 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.0735993,46 C38.0888476,46 35.335714,44.3819591 33.8868693,41.7750241 L17.4600579,12.2067636 C15.2605078,8.24790201 16.6912831,3.23772453 20.6501446,1.0365318 C21.869014,0.35974717 23.2472235,0 24.6336464,0 C27.6167553,0 30.3698889,1.61968361 31.8187337,4.22661858 L48.2455451,33.7948791 C50.4450952,37.7537407 49.0143199,42.7639182 45.0554583,44.9651109 C43.8382316,45.6418955 42.4600221,46 41.0735993,46 Z M24.6352891,1.64268114 C23.5264793,1.64268114 22.4258829,1.93015034 21.4484877,2.4738778 C18.2813984,4.23154662 17.1364497,8.24133129 18.8957612,11.4067778 L35.3225726,40.9750384 C36.4806628,43.0612434 38.6834982,44.3573189 41.0719566,44.3573189 C42.1791237,44.3573189 43.2813627,44.0698497 44.2571153,43.5277649 C47.4242045,41.7700961 48.5691533,37.7603114 46.8098418,34.5948648 L30.3830304,5.02660429 C29.2265829,2.93875656 27.0237475,1.64268114 24.6352891,1.64268114 Z",
    id: "Shape"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogle);
export default __webpack_public_path__ + "static/media/Google.cab8dd4184238aace32fa5f694b352b8.svg";
export { ForwardRef as ReactComponent };